import 'typeface-roboto';
import './styles/CourseCatalog.css';

import React, { useEffect, useState } from 'react';

import ApolloClientService from '../shared/services/ApolloClientService';
import { ApolloProvider } from '@apollo/client';
import AuthService from '../shared/services/AuthService';
import Config from '../shared/config';
import CourseCatalogContainer from './components/CourseCatalogContainer';
import { User } from 'oidc-client';

const CourseCatalog = () => {
  const [user, setUser] = useState<User>(null);

  useEffect(() => {
    setUser(AuthService.getUser());
  }, []);

  const graphQLQueryEndpoint = Config.GROUP_GQL;
  const apolloClient = ApolloClientService.create(graphQLQueryEndpoint);

  return user ? (
    <div className="course-catalog-container">
      <ApolloProvider client={apolloClient}>
          <div>
            <CourseCatalogContainer />
          </div>
      </ApolloProvider>
    </div>
  ) : (
    <p>Loading...</p>
  );
};

export default CourseCatalog;
